import Box from '@mui/material/Box';

import { CONFIG } from 'src/global-config';

import { AiChat } from 'src/sections/ai-chat';

import { useAuthContext } from 'src/auth/hooks';
import { AuthDialog } from 'src/auth/components/auth-dialog';

// ----------------------------------------------------------------------

const metadata = { title: `MVP - ${CONFIG.appName}` };

export default function MvpPage() {
  const { authenticated, loading } = useAuthContext();

  return (
    <>
      <title>{metadata.title}</title>

      <Box
        sx={{
          display: 'flex',
          flex: '1 1 auto',
          flexDirection: 'column',
          justifyContent: 'center',
          height: 'calc(100vh - 64px)',
        }}
      >
        <AiChat />
      </Box>

      <AuthDialog open={!authenticated && !loading} />
    </>
  );
}
